<template>
    <div class="root_wp_frm">
        <div class="logo_modal_login">
            <div class="logo_mdal">
                <div class="img_mdal">
                    <img src="../assets/images/logo.png" alt="">
                </div>
            </div>
        </div>
        <div class="form_dangky">
            <div class="root_register">
                <form action="" method="post" id="frm_register" @submit="register">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12 left_frm_register">
                            <div class="wrapper_left_register">
                                <div class="input_dk">
                                    <label><img src="../assets/images/star.png" alt=""> Tên tài khoản</label>
                                    <input type="text" v-model="username" placeholder="">
                                    <p class="lable_title">Lớn Hơn 5 Ký Tự, Bằng Chữ, Không Thêm Các Ký Tự Đặc Biệt.</p>
                                </div>
                                <div class="input_dk">
                                    <label><img src="../assets/images/star.png" alt=""> Mật khẩu thành viên</label>
                                    <input :type="showPassword ? 'text' : 'password'" v-model="password" placeholder="">
                                    <p class="lable_title lable_title2">Hơn 6 Ký Tự Phải Bao Gồm Chữ Cái Và Số.</p>
                                    <img src="../assets/images/eye1.png" @click="togglePassword" alt="" class="iconpassword" v-if="showPassword">
                                    <img src="../assets/images/eye.png" @click="togglePassword" alt="" class="iconpassword" v-else>
                                </div>
                                <div class="input_dk">
                                    <label><img src="../assets/images/star.png" alt=""> Xác nhận mật khẩu</label>
                                    <input :type="showPassword1 ? 'text' : 'password'" v-model="password_confirm" placeholder="">
                                    <p class="lable_title">Vui Lòng Xác Nhận Lại Mật Khẩu Của bạn.</p>
                                    <img src="../assets/images/eye1.png" @click="togglePassword1" alt="" class="iconpassword" v-if="showPassword1">
                                    <img src="../assets/images/eye.png" @click="togglePassword1" alt="" class="iconpassword" v-else>
                                </div>
                                <div class="input_dk">
                                    <label><img src="../assets/images/star.png" alt=""> Email</label>
                                    <input type="email" v-model="email" placeholder="">
                                    <p class="lable_title">Vui lòng nhập email</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12 right_frm_register">
                            <div class="wrapper_left_register">
                                <div class="input_dk">
                                    <label><img src="../assets/images/star.png" alt=""> Tên thật</label>
                                    <input type="text" v-model="name" placeholder="">
                                    <p class="lable_title lable_title1">Họ Tên Ghi In Hoa, Không Dấu, VD: NGUYEN VAN A</p>
                                </div>
                                <div class="input_dk">
                                    <label><img src="../assets/images/star.png" alt=""> Số điện thoại</label>
                                    <input type="text" v-model="phone" placeholder="">
                                    <p class="lable_title">SĐT Bắt Đầu Bằng 84, Ví Dụ 84988889999. Nhập Chính Xác Số Điện Thoại Để Tự Khôi Phục Lại Mật Khẩu Khi Bạn Quên Mật Khẩu</p>
                                </div>
                                <div class="input_dk">
                                    <label><img src="../assets/images/star.png" alt=""> Mã xác minh</label>
                                    <div class="codecapchar_dk">
                                        <input type="text" class="codeCapchar" placeholder="">
                                        <div class="capcharCheck">
                                            <span>{{ codeCapchar }}</span>
                                            <button type="button" @click="reloadCapchar" class="resetcapchar"></button>
                                        </div>
                                    </div>
                                    <p class="lable_title">Xin Vui Lòng Nhập Mã Xác Minh.</p>
                                </div>
                                <div class="input_dky">
                                    <p class="checkagea"><input type="checkbox" checked> Đã đủ 18 tuổi và đồng ý với trang web này <span>Thỏa thuận đăng ký người dùng</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="input_dky">
                        <p class="checkagea"><input type="checkbox" checked> Đã đủ 18 tuổi và đồng ý với trang web này <span>Thỏa thuận đăng ký người dùng</span></p>
                    </div> -->
                    <div class="btn_dangky">
                        <button type="submit">Đăng ký ngay</button>
                    </div>
                    <div class="wp_linkLogingk">
                        <h3><span>Link dễ nhớ:</span> <a href="https://gk88live.com" target="_blank">GK88LIVE1.COM</a></h3>
                        <p>Nếu bạn bị chặn không truy cập được vào trang vui lòng truy cập theo đường Link Dễ Nhớ để có thể truy cập vào trang nhanh nhất nhé</p>
                    </div>
                    <div class="wp_downloadapp wp_downloadapps">
                        <img src="../assets/images/dw.png" alt="">
                        <a :href="android" download class="dladr"><img src="../assets/images/adr.png" alt=""></a>
                        <a :href="ios" target="_blank" class="dlios"><img src="../assets/images/ios.png" alt=""></a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'Register_f8',
    data () {
        return {
            codeCapchar: Math.floor(1000 + Math.random() * 9000),
            name: '',
            email: '',
            phone: '',
            username: '',
            password: '',
            password_confirm: '',
            codeParam: '',
            android: '',
            ios: '',
            showPassword: false,
            showPassword1: false
        }
    },
    components: {
    },
    mounted() {
        
    },
    created () {
        this.getInfoLink()
    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        togglePassword1() {
            this.showPassword1 = !this.showPassword1;
        },
        getInfoLink () {
            this.axios.get(this.api_previewLink + '?domain=' + this.url_param).then((response) => {
                this.linkforgot_lg = response.data.data.list_data.link_password;
                this.android = response.data.data.list_data.android;
                this.ios = response.data.data.list_data.ios;
            })
        },
        register (e) {
            e.preventDefault()
            $('#loading_show').show().fadeIn(10)
            let capchar = $('.codeCapchar').val()
            if(capchar == ''){
                $('#loading_show').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Vui lòng nhập mã xác nhận',
                    showConfirmButton: false,
                    timer: 3000
                })
            }else if(capchar != this.codeCapchar){
                $('#loading_show').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Mã xác nhận không đúng',
                    showConfirmButton: false,
                    timer: 3000
                })
            }else{
                this.axios.post(this.api_register78win, {
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    username: this.username,
                    password: this.password,
                    password_confirm: this.password_confirm,
                    referrer: this.codeParam,
                    random: this.randomValue
                }).then(res => {
                    $('#loading_show').css('display', 'none')
                    this.$swal({
                        position: 'top-end',
                        icon: 'success',
                        title: res.data.message,
                        showConfirmButton: false,
                        timer: 4000
                    })
                    this.showModal_dk = false
                    this.name = this.username = this.email = this.password = this.password_confirm = this.phone = ''
                    window.location.reload()
                }).catch(e => {
                    $('#loading_show').css('display', 'none')
                    this.modalCaptcha = false
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: e.response.data.message,
                        showConfirmButton: false,
                        timer: 3000
                    })
                })
            }
        },
        reloadCapchar () {
            this.codeCapchar = Math.floor(1000 + Math.random() * 9000)
        },
        handleClick () {
            this.$emit('showMd')
        },
    }
}
</script>
<style>
</style>
